export default __webpack_public_path__ + "static/media/ROM SYLLABUS_2026-27 CLASS 10.d6c6971f.pdf";